<template>
  <div>
    <v-data-table
      item-key="id"
      :options.sync="busTableOptions"
      :items-per-page="10"
      :server-items-length="totalItems"
      :headers="headers"
      :footer-props="footerTable"
      :items="busesData"
      sort-by="name"
      @input="$emit('update:selected', $event)"
      v-bind="this.$attrs"
      loading-text="Đang Tải"
      :loading="loading"
      no-data-text="Không có xe"
      disable-sort
    >
      <template v-slot:[`item.name`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <div v-on="on" style="text-decoration: none; white-space: nowrap">
              <router-link v-on="on" style="text-decoration: none; white-space: nowrap" :to="'/bus/' + item.id">{{
                item.name
              }}</router-link>
            </div>
          </template>
          <span>Xem tuyến xe</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.maxStudent`]="{ item }">
        {{ item.data && item.data.maxStudent }}
      </template>
      <template v-slot:[`item.driver`]="{ item }">
        <router-link style="text-decoration: none" :to="'/teacher/' + get(item, 'driver.id')">
          {{ get(item, 'driver.name') }}
        </router-link>
      </template>
      <template v-slot:[`item.phone`]="{ item }">
        {{ item.phone }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-chip
          small
          style="margin: 0"
          class="white--text"
          v-if="item.status"
          :color="item.status | busStatusColor"
          label
        >
          {{ item.status | busStatus }}
        </v-chip>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="() => $router.push({ path: `bus/${item.id}` })" icon>
              <v-icon center color="grey darken-1">mdi-eye</v-icon>
            </v-btn>
          </template>
          <span>Xem chi tiết</span>
        </v-tooltip>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title
                class="primary--text"
                style="cursor: pointer"
                @click="() => $refs.busNewDialog.openDialog('update', item)"
                >Sửa</v-list-item-title
              >
            </v-list-item>
            <v-list-item>
              <v-list-item-title class="red--text" style="cursor: pointer" @click="deleteBus(item.id)"
                >Xóa</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <BusNewDialog ref="busNewDialog" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import BusNewDialog from '@/modules/bus/busNewDialog.vue'

const originHeaders = [
  { text: 'Xe tuyến', value: 'name' },
  { text: 'GV phụ trách', value: 'driver', width: '200px' },
  { text: 'SDT GV phụ trách ', value: 'phone', align: 'center' },
  { text: 'Số học sinh tối đa', value: 'maxStudent' },
  { text: 'Tình trạng', value: 'status' },
  { text: 'Thao tác', value: 'action', align: 'center', width: '130px' }
]

export default {
  components: { BusNewDialog },
  props: {},
  data() {
    return {
      selected: [],
      search: '',
      headers: originHeaders,
      editingItem: null,
      status: null,
      busTableOptions: {}
    }
  },
  methods: {
    ...mapActions({
      requestPageSettings: 'bus/requestPageSettings',
      searchBuses: 'bus/searchBuses',
      removeBus: 'bus/removeBus'
    }),
    get,
    cancel() {
      this.$emit('cancel')
      this.dialog = false
    },
    deleteBus(id) {
      this.$dialog.confirm({
        title: 'Xác nhận xoá tuyến xe',
        text: 'Xoá xe tuyến sẽ ảnh hưởng tới các dữ liệu của xe tuyến này. Có chắc chắn muốn xóa tuyến xe?',
        okText: 'Xoá',
        cancelText: 'Hủy',
        type: 'delete',
        done: async () => {
          try {
            this.$loading.active = true
            await this.removeBus(id)
            this.$alert.success('Xóa xe tuyến thành này')
            this.refresh({})
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
    async refresh(query) {
      query = query || {}
      this.searchBuses({
        ...query
      })
    }
  },
  computed: {
    ...mapState('bus', ['busesData', 'totalItems', 'pageText', 'loading']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Tuyến xe mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  watch: {
    busTableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
